import { render, staticRenderFns } from "./DemoAdsAccount.vue?vue&type=template&id=f6701f96&scoped=true&"
import script from "./DemoAdsAccount.vue?vue&type=script&lang=js&"
export * from "./DemoAdsAccount.vue?vue&type=script&lang=js&"
import style0 from "./DemoAdsAccount.vue?vue&type=style&index=0&id=f6701f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6701f96",
  null
  
)

export default component.exports